import { Checkbox, CheckboxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const BaseCheckBox = styled(Checkbox)<CheckboxProps>(({ theme }) => ({}));

export default BaseCheckBox;
